import React, { FC } from 'react';
import { buttonLabel, isDefault, mqTaken } from './card.utils';
import { MQButton } from './MQButton';
import { CardVariant, ProductCardAttributesValues, ProductCardGenericLabels } from './ProductCard';
import { SelectPlanButton } from './SelectPlanButton';

export const CardBottom: FC<{
  isMqRequired: boolean;
  isMqTaken: boolean;
  genericLabels: ProductCardGenericLabels;
  onSelect: (paxId: number, code: string, cardParams: Record<string, string>) => void;
  onDeselect: (paxId: number, code: string) => void;
  mqAction: (paxId: number, action: string) => void;
  paxId: number;
  id: string;
  code: string;
  name: string;
  isValid: boolean;
  cardParams: ProductCardAttributesValues;
  isSelected: boolean;
  isAddOn: boolean;
  isMqEligible?: boolean;
  variant?: CardVariant;
}> = ({
  isMqRequired,
  isMqTaken,
  genericLabels,
  onSelect,
  onDeselect,
  mqAction,
  paxId,
  id,
  code,
  name,
  isValid,
  isAddOn,
  isSelected,
  cardParams,
  isMqEligible,
  variant
}) => {
  const selectPlanLabel = buttonLabel(isAddOn, isSelected, genericLabels);
  const defaultType = isDefault(variant);
  const mqValid = mqTaken(isMqRequired, isMqTaken) && (defaultType || isMqEligible);
  const buttonValid = isValid && mqValid;
  return (
    <div className="py-3 d-flex justify-content-center select-plan">
      {isMqRequired && !isMqTaken && defaultType && (
        <MQButton
          genericLabels={genericLabels}
          isMqTaken={isMqTaken}
          mqAction={mqAction}
          paxId={paxId}
          id={`${id}-mq-button`}
        />
      )}
      {(mqValid || !defaultType) && (
        <SelectPlanButton
          isAddOn={isAddOn}
          code={code}
          isValid={buttonValid}
          name={name}
          onDeselect={onDeselect}
          onSelect={onSelect}
          paxId={paxId}
          selectPlanLabel={selectPlanLabel}
          values={cardParams}
          isSelected={isSelected}
          id={`${id}-plan-button`}
        />
      )}
    </div>
  );
};
CardBottom.displayName = 'CardBottom';
export default CardBottom;
